module.exports = __webpack_public_path__ + "img/page-not-found.04b97252.jpg";